import React from 'react';
import { Menu, MenuItem } from '@mui/material';

const ContextMenu = ({ anchorEl, handleClose, menuOptions }) => {
  return (
    <Menu
      anchorEl={anchorEl}
      keepMounted
      open={Boolean(anchorEl)}
      onClose={handleClose}
      onClick={handleClose}
    >
      {menuOptions.map((option, index) => (
        <MenuItem
          key={index}
          onClick={option.action}
        >
          {option.label}
        </MenuItem>
      ))}
    </Menu>
  );
};

export default ContextMenu;
